// Shared period-scope toggle + picker for operational pipeline pages.
// Returns the active filter so each page can apply it however it stores dates.

import React, { useMemo, useState } from "react";
import PeriodPicker from "./PeriodPicker";

const todayKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const monthOf = (s) => (typeof s === "string" ? s.slice(0, 7) : "");

export const usePeriodFilter = (initialScope = "all") => {
  const [period, setPeriod] = useState(todayKey());
  const [scope, setScope] = useState(initialScope);

  const filterByDate = useMemo(() => {
    if (scope === "all") return () => true;
    return (rawDate) => monthOf(rawDate) === period;
  }, [scope, period]);

  return { period, setPeriod, scope, setScope, filterByDate };
};

const PeriodScopeBar = ({ scope, setScope, period, setPeriod, testidPrefix = "scope" }) => (
  <div className="flex items-center gap-3 flex-wrap">
    <div className="flex border border-[rgba(42,28,21,0.18)] bg-[#E7DDCB]">
      <button
        data-testid={`${testidPrefix}-all`}
        onClick={() => setScope("all")}
        className={`px-3 py-1.5 font-body tracking-widest text-[0.75rem] uppercase ${scope === "all" ? "bg-[#2A1C15] text-[#DCCFB9]" : "text-[#2A1C15] hover:bg-[#2A1C15]/5"}`}
      >All</button>
      <button
        data-testid={`${testidPrefix}-period`}
        onClick={() => setScope("period")}
        className={`px-3 py-1.5 font-body tracking-widest text-[0.75rem] uppercase border-l border-[rgba(42,28,21,0.18)] ${scope === "period" ? "bg-[#2A1C15] text-[#DCCFB9]" : "text-[#2A1C15] hover:bg-[#2A1C15]/5"}`}
      >Month</button>
    </div>
    {scope === "period" && <PeriodPicker value={period} onChange={setPeriod} />}
  </div>
);

export default PeriodScopeBar;
